exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.citsci-project-icon[data-v-2a1f5757] {\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);

// exports
